import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';
import PAGE_COMPONENT from './SingleEvent';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};
ReactDOMClient.hydrateRoot(
    document.getElementById('root'),
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>
);

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 
*  To render the component:
*
*  req.reactRender = {
*      componentPath: 'Events/SingleEvent/SingleEvent,
*      props: {},
*      metaTagData:{}
*  }
*
*  next();
*  return;
*

 */
